import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['headerCta', 'mobileCta'];

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            this.mobileCtaTarget.classList.remove('hidden');
          } else {
            this.mobileCtaTarget.classList.add('hidden');
          }
        });
      },
      {
        threshold: 0,
        rootMargin: '0px'
      }
    );

    this.observer.observe(this.headerCtaTarget);
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
